import { useState, useEffect } from 'react';
import { ofType, getCommunicationService } from 'utils/communicationService';
import { filter } from 'rxjs/operators';
import { AD_EVENT_UAP_LOAD_STATUS } from 'utils/communicationService/adEngineTypes';
const adSlotLoadedEvent = '[AdEngine] Ad Slot event';
export default function useAdConflictListener() {
    const [isAdConflict, setIsAdConflict] = useState(true);
    const communicationService = getCommunicationService();
    useEffect(() => {
        communicationService.actions
            .pipe(ofType(adSlotLoadedEvent), filter(({ event, payload }) => payload.provider === 'nativo' && event === 'disabled'))
            .subscribe(() => setIsAdConflict(false));
        // listen when UAP is displayed => there will be no nativo ad
        communicationService.actions
            .pipe(ofType(AD_EVENT_UAP_LOAD_STATUS), filter(({ isLoaded }) => isLoaded))
            .subscribe(() => setIsAdConflict(false));
    }, [communicationService]);
    return isAdConflict;
}
